
export default {
	getTrackingUserTrackingId: ({ userTrackingId }) => userTrackingId,
	getTrackingEvents: ({ events }) => events,
	getTrackingTaskId: ({ taskId }) => taskId,
	getTrackingStatus: ({ tracking }) => tracking,
	getTrackingPermission: ({ canTrack }) => canTrack,
	getTrackingCurrentlyActiveTask: ({ currentlyActiveTask }) => currentlyActiveTask,
	getTrackingEstimate: ({ estimate }) => estimate,
}